import { type FieldValues, type UseFormReturn, useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

export interface HookFormProps<_T extends FieldValues>
  extends Omit<React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>, 'onSubmit'> {
  noDefaultClass?: boolean;
}
export const HookForm = <T extends FieldValues = FieldValues>(
  props: {
    onSubmit: Parameters<UseFormReturn<T>['handleSubmit']>[0];
    onError?: Parameters<UseFormReturn<T>['handleSubmit']>[1];
  } & HookFormProps<T>
) => {
  const { children, onSubmit, onError, className = '', noDefaultClass = false, ...rest } = props;
  const { handleSubmit } = useFormContext<T>();

  return (
    <form
      onSubmit={handleSubmit(onSubmit, onError)}
      {...rest}
      className={twMerge([!noDefaultClass && 'bg-white relative w-full h-full', className])}
    >
      {children}
    </form>
  );
};
